import React, { Component } from 'react'

/* Poker UI */
import { Chip3D } from '@cuba-go/poker-ui'

/* Constants */
import { sound } from '../constants'
import { BET, DOUBLE, SUPER, BET_NAMES, BET_NAMES_CN, SPOTS, showsLoss } from '../constants/values'


/* THE THREE SPOTS OF ONE BOX — THE PRINTING ON THE CLOTH AND NOTHING ELSE

   Super Double at the top, Double Bet under it, Normal Bet at the bottom — the order they
   are printed. Nothing about them is linked: a player may put chips on one of them, on
   two, or on all three, and each is settled on its own against the dealer's hand.

   No chips are drawn here when the group is on the felt. The felt leans away from the
   player and everything inside it leans with it, and a chip is not printing — it is an
   object lying on top. So the chips are a layer of their own, laid over the band by
   Boxes.js, and all this component does for them is leave an anchor at the middle of each
   spot for that layer to aim at. The phone strips are flat, and there the chips have
   nowhere else to be, so they are drawn in place — that is what `inlineChips` is for. */

class NiuRate extends Component {

    /* The result of this spot once the round is paid, if there is one */
    outcome = type => {

        const { result } = this.props

        if (!result || !result.bets || !result.bets[type]) return null

        return result.bets[type]
    }

    /* Whether anything of this player's is standing on the spot right now. A spot the
       dealer took is empty by the time the player looks at it — the chips have gone
       across the line — so the stake comes off the felt as soon as the round is read. */
    hasChips = type => {

        const value = this.props[type]
        const outcome = this.outcome(type)

        if (outcome && this.props.result.result === "lose") return false

        return !!value
    }

    /* The name printed on the spot, which the chips cover while they are on it */
    _name = type => {

        const { chinese } = this.props

        const names = chinese ? BET_NAMES_CN : BET_NAMES

        return <p className={`niu-spot-name ${chinese ? "niu-spot-name-cn" : ""}`}>{names[type]}</p>
    }

    /* Chips drawn where they stand, for the flat strips at the foot of a phone */
    _inline = type => {

        /* The size is the caller's, not this component's: it is the one the band draws its
           chips at, and a chip on a strip and a chip on the felt are the same object. */
        const { chips, chipSize = 40 } = this.props

        const value = this.props[type]
        const outcome = this.outcome(type)

        return (
            <>
                {/* The name stays put and the chip is laid over it, rather than the one
                    being swapped for the other. Swapping leaves nothing on the spot to
                    fade, so the printing could not show through the way it does on the
                    felt — .niu-spot-chip is positioned over the middle of the cell, so
                    the two sit on top of one another without either being removed. */}
                {this._name(type)}

                {this.hasChips(type) ?
                    <div className="niu-spot-chip">
                        <Chip3D value={value} size={chipSize} chips={chips} />
                    </div>
                    : null}

                {outcome && outcome.win ?
                    <div className="niu-spot-result">
                        <div className="niu-spot-multiplier">{outcome.coefficient}x</div>
                        <div className="niu-spot-result-chip">
                            <Chip3D value={outcome.win} size={chipSize} chips={chips} />
                        </div>
                    </div>
                    : null}

                {/* Same rule the felt goes by: only a stake that can be charged above its
                    face is told to the player as a figure. On the Bet and the Double Bet
                    the chip simply goes — see showsLoss. */}
                {outcome && outcome.lose && showsLoss(type) ?
                    <div className="niu-spot-lost">
                        <div className="niu-spot-multiplier niu-spot-multiplier-lost">−{outcome.coefficient}x</div>
                    </div>
                    : null}
            </>
        )
    }

    add = type => {

        const { add, isChoice } = this.props

        if (!isChoice) {
            sound.play("blocked")
            return
        }

        add(type)
    }

    _spot = type => {

        const { isChoice, isActive, backColor, result, inlineChips, anchor } = this.props

        const value = this.props[type]

        /* An empty spot pulses while the bets are being taken — it is an offer, and it has
           to look like one */
        const animation = isChoice && !value && isActive ? "animated" : ""
        const available = isChoice ? "cursor" : ""

        /* The printing stays under the chips rather than being replaced by them, so the
           spot reads the same whether or not anything is standing on it. It applies to
           the phone strips as well as the felt — how far the name fades is one rule in
           niu-rates.css, and both should answer to it. */
        const covered = this.hasChips(type) ? "niu-spot-covered" : ""

        return (
            <div className={`niu-spot niu-spot-${type} ${covered} ${result ? "niu-spot-settled" : ""}`} key={`spot-${type}`}>

                <div className={`niu-spot-fill ${animation}`} style={{ backgroundColor: backColor }} />

                <div className={`niu-spot-face ${available}`} onClick={() => this.add(type)}>

                    {inlineChips ? this._inline(type) : this._name(type)}

                    {/* A point of no size at the middle of the spot. It goes through the
                        band's tilt with everything else, so wherever it lands on screen is
                        exactly where a chip on this spot belongs — which is what the chip
                        layer measures instead of trying to work the projection out. */}
                    {!inlineChips ? <i className="niu-spot-anchor" ref={el => anchor && anchor(type, el)} /> : null}

                </div>

            </div>
        )
    }

    render = () => {

        const { disabled, loading } = this.props

        return (
            <div className={`niu-rate ${disabled ? "disabled" : ""}`}>

                {loading ?
                    <div className='is-loading'>
                        <div className='box-spinner-loader' />
                    </div> : null
                }

                {/* The three spots share their edges inside one printed frame, the way they
                    are painted on the cloth — one white outline round the group, a line
                    between each pair. The blue panels are not part of a box: there are two
                    of them for the whole row and they live in Boxes.js, between the groups. */}
                <div className="niu-rate-strip">
                    {SPOTS.map(type => this._spot(type))}
                </div>

            </div>
        )
    }

}

export default NiuRate
